"use client";

import Image from "next/image";
import { GalleryModal } from "../common/ui/gallery_modal/galleryModal";
import { useState } from "react";

interface GalleryProps {
  images: {
    url: string | null;
    alt: string | null;
  }[];
}

export const Gallery = ({ images }: GalleryProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [clickedImage, setClickedImage] = useState("");
  
  // Helper to safely get the image URL array
  const imageUrls = images.map((image) => image.url || "");

  return (
    <section className="grid lg:grid-cols-3 grid-cols-2 gap-x-5 gap-y-5 mt-5">
      {images?.map((image, index) => (
        <figure key={index} className="relative aspect-[413/232] h-full w-full">
          <Image
            src={image.url || "c078d688-c930-4a5e-8344-8730fdcb9602.jpeg"}
            fill
            sizes="(min-width: 1328px) 414px, (min-width: 1024px) 33vw, 50vw"
            className="object-cover object-bottom hover:opacity-60 transition-opacity duration-300 ease-in-out cursor-pointer"
            alt="testing"
            loading="lazy"
            onClick={() => {
              if (image.url) { 
                setClickedImage(image.url); 
                setIsOpen(true);
              }
            }}
          />
        </figure>
      ))}
      <GalleryModal
        selectedImage={clickedImage}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        allImages={imageUrls}
      />
    </section>
  );
};